export const PagingConstant = {
  SERVER_PAGESIZE: 100,
};
